<template>
  <v-content>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t("ResetPasswordForm.FormTopic") }}</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <v-form ref="passwordResetForm" @keyup.native.enter="BtnChangePasword">
                <v-text-field
                  :label="label_login"
                  prepend-icon="mdi-login"
                  v-model="login"
                  id="login"
                  name="login"
                  required
                  :rules="rules_login"
                ></v-text-field>
                <v-text-field
                  :label="label_newPassword"
                  prepend-icon="mdi-lock-outline"
                  v-model="newPassword"
                  id="newPassword"
                  name="newPassword"
                  required
                  :rules="rules_newPassword"
                  :append-icon="disableBtnChangePasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="disableBtnChangePasswordShow ? 'password' : 'text'"
                  @click:append="() => (disableBtnChangePasswordShow = !disableBtnChangePasswordShow)"
                ></v-text-field>
              <v-card-actions>
              <v-spacer />
              <v-btn
                v-if="valid"
                color="primary"
                @click="BtnChangePasword"
                :loading="loadingBtn"
                :disabled="disableBtnChangePassword"
                >{{ $t("ResetPasswordForm.ChangePassword") }}</v-btn
              >
            </v-card-actions>

            </v-form>
            </v-card-text>

            
            <v-snackbar v-model="snack" :timeout="2000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
            </v-snackbar>

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>

export default {
  data: () => ({
    
    snack: false,
    snackColor: "",
    snackText: "",
    
    userPassword: "",
    valid: true,

    loadingBtn: false,
    disableBtnChangePassword: true,
    disableBtnChangePasswordShow: true,
    login: "",
    newPassword: "",
    menu: "",
    rules_login: [
      value => !!value || "Pole wymagane",
      value => {
        return value == value || "Invalid password.";
      }
    ],
    rules_newPassword: [
      value => !!value || "Pole wymagane",
      value => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/.test(value) || 'Min. 8 znaków z co najmniej jedną wielką literą, liczbą i znakami specjalnymi.',
      value => {
        return value == value || "Invalid password.";
      }
    ],
  }),

  methods: {
    async BtnChangePasword() {
      this.loadingBtn = true;
      const LoginResetData = {
        login:  this.login,
        newPassword: this.newPassword,
        token: this.$route.query.Token
      };
    
      await window.Store.dispatch("resetPassword", LoginResetData)
        .then(response => {
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Hasło zostało zmienione";
          this.Answer = response;
          this.loadingBtn = false;
          setTimeout( () => this.$router.push({ path: '/'}), 3000);
        })
        .catch(errors => {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Błąd w trakcie zmieniania hasła";
          this.Answer = errors;
          this.loadingBtn = false;
          setTimeout( () => this.$router.push({ path: '/'}), 3000);
        });
    },
    ButResetPassword: function() {
      this.dialogResetPassword = true;
    }
    
  },
   watch: {
     login: {
       handler: function() {
          this.disableBtnChangePassword = !this.$refs.passwordResetForm.validate();
       },
       deep: true
     },
     newPassword: {
       handler: function() {
         this.disableBtnChangePassword = !this.$refs.passwordResetForm.validate();
       },
       deep: true
     }
  },
  computed: {
    label_login: function() {
      return this.$t("ResetPasswordForm.Login");
    },
    label_newPassword: function() {
      return this.$t("ResetPasswordForm.NewPassword");
    }

  }
};
</script>
